import React, { useEffect, useState } from 'react';

import { Box, Stack, useDisclosure } from '@chakra-ui/react';

import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { AggregatedAlertsTable } from 'containers/Findings/Alerts/Components/AlertsTable/AggregatedAlertsTable';
import { AlertFilters } from 'containers/Findings/Alerts/Components/AlertsTable/AlertFilters';
import { AlertsTableHeader } from 'containers/Findings/Alerts/Components/AlertsTable/AlertsTableHeader';
import { useFindingsIssueContext } from 'containers/Findings/Alerts/Components/AlertsTable/hooks/context';
import { ViewIssuesBy } from 'containers/Findings/Alerts/Components/AlertsTable/ViewIssuesBy';

export const AggregatedAlerts = () => {
  const { getAggregatedFindings } = useFindingsIssueContext();
  const excludeResources = useDisclosure();
  const [selectedResources, setSelectedResources] = useState<string[]>([]);

  useEffect(() => {
    getAggregatedFindings();
  }, [getAggregatedFindings]);

  return (
    <Stack h="full" spacing={5} w="full">
      <AlertsTableHeader
        excludeResources={excludeResources}
        selectedResources={selectedResources}
      />
      <ViewIssuesBy />
      <BorderedBox h="full">
        <Stack h="full" spacing={5}>
          <AlertFilters />
          <Box flex={1} h="full">
            <ActiveResourceProvider>
              <AggregatedAlertsTable
                excludeResources={excludeResources}
                selectedResources={selectedResources}
                setSelectedResources={setSelectedResources}
              />
            </ActiveResourceProvider>
          </Box>
        </Stack>
      </BorderedBox>
    </Stack>
  );
};
